import { Component, OnInit } from '@angular/core';
import { AuthService } from '@abp/ng.core';
import { Router } from '@angular/router';
import { ThemeService, StyleNames, lightTheme } from '@volosoft/ngx-lepton-x';
import { environment } from '../environments/environment';


@Component({
  standalone: false,
  selector: 'app-root',
  template: `  
  <router-outlet></router-outlet>
	<abp-gdpr-cookie-consent></abp-gdpr-cookie-consent> 
  `,
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    // Force Light Theme (bootstrap-light)
    this.themeService.setTheme(lightTheme);

    if (this.themeService.selectedStyle.styleName !== StyleNames.Light) {
      this.themeService.setTheme(lightTheme);
    }

    // Listen for authentication completion
    if (this.authService.isAuthenticated) {

      // Only redirect to home if we're on the root path or landing page
      const currentUrl = this.router.url;

      // Exclude account management and settings pages from auto-redirect
      const excludedPaths = [
        '/account/management',
        '/personal-settings',
        '/change-password',
        '/notifications',
        '/settings',
        '/admin'
      ];

      const shouldRedirect =
        (currentUrl === '/' ||
          currentUrl === '' ||
          currentUrl === '/landing') &&
        !excludedPaths.some(path => currentUrl.startsWith(path));

      if (shouldRedirect) {
        // ✅ KEY FIX: navigate FIRST, hide overlay AFTER navigation completes.
        // router.navigate() resolves after NavigationEnd, meaning HomeComponent
        // is already rendered before the overlay fades out — no blank screen.
        this.router.navigate(['/home']).then(() => {
          const overlay = document.getElementById('instant-landing');
          if (overlay) {
            overlay.classList.add('fade-out');
            setTimeout(() => { if (overlay) overlay.style.display = 'none'; }, 350);
          }
        });
      }
    }
  }
}